import React, { useEffect, useState } from 'react';
import { Box, FormLabel, Link, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { BackArrow } from '../../../../config/svg/GlobalSvg';
import '../../../../styles/pages/admin/settings/default-okr/createDefaultOkr.scss';
import { CalendarIcon } from '../../../../config/svg/CommonSvgIcon';
import { Enums } from '../../../../config/enums';
import ReactDateRangePicker from '../../../Common/ReactDateRangePicker';
// import { getLocalStorageItem } from '../../../../../../services/StorageService';
import { getCycleDefaultSelection } from '../../../../config/utils';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { CreateDefaultKpiDetails } from './CreateDefaultKpiDetails';
import { DefaultKpiAttributes } from './DefaultKpiAttributes';
import AlertDialog from '../../../Common/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { defaultOkrDelete } from '../../../../action/adminDefaultOkr';
import { getLocalStorageItem } from '../../../../services/StorageService';
import { MainDrawer } from '../../../Admin/CommonComponent/MainDrawer';
import { DialogComponent } from '../../../Admin/CommonComponent/DialogComponent';
import { createDefaultKpi, editDefaultKpi, setKpiListReload, setShowKpiCreateOpen } from '../../../../action/MyKpis';

export const CreateDefaultKpi: React.FC<any> = (props: any) => {
	const {
		defaultOkrDetailsObj,
		setDefaultOkrOpen,
		setTabSelected,
		allCycleDetails,
		cycleId,
		defaultGoalKeyObject,
		defaultOkrFormDetails,
		setDefaultOkrFormDetails,
		defaultOkrDesignationDetails,
		defaultOkPerformanceRoleDetails,
		selectedCycleDetailsInTab,
		isDefaultOkrFormEditedData,
		setIsDefaultOkrFormEditedData,
		mode = 'Add',
		// editDetails,
		showLoader,
		setShowLoader,
		setEditDetails,
		setSelectedCycle,
		setSelectedOkrListCycleDetails,
		showApiMsg,
		setIsDefaultOkrFormEdited,
		refObject,
		setHighlightDefaultOkr,
		openDefaultObjDrawer,
		setOpenDefaultObjDrawer,
		openDefaultKrDrawer,
		setOpenDefaultKrDrawer,
		weightSelectionOpen,
		setWeightSelectionOpen,
	} = props;
	const dispatch = useDispatch();
	const moment = extendMoment(Moment);
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const { okrMasterData } = useSelector((state: any) => state.okrReducer);
	const cycleDuration = getLocalStorageItem('cycleDuration') || null;
	// const allCycleDetails = getLocalStorageItem('cycleDetail') && JSON.parse(getLocalStorageItem('cycleDetail') || '');
	// const cycleId = getLocalStorageItem('cycleId') ? parseInt(getLocalStorageItem('cycleId') || '0') : 0;
	// const currentCycleYear = getLocalStorageItem('year') || null;

	const [selectedCycleDetails, setSelectedCycleDetails] = useState<any>(null);
	const [isCurrentCycle, setIsCurrentCycle] = useState<any>(null);
	// const [currentCycleId, setCurrentCycleId] = useState(cycleId);
	const [selectedDateRange, setSelectedDateRange] = useState<any>(null);
	// const [selectedKrCycleDetails, setSelectedKrCycleDetails] = useState<any>(null);
	// const [selectedKrDateRange, setSelectedKrDateRange] = useState<any>(null);
	const [selectedDesignationOptions, setSelectedDesignationOptions] = useState<any>([]);
	const [selectedPerformanceRoleOptions, setSelectedPerformanceRoleOptions] = useState<any>([]);
	const [selectedUsersOptions, setSelectedUsersOptions] = useState<any>([]);
	const [defaultOkrFormEdited, setDefaultOkrFormEdited] = useState<any>(false);
	const [selectedRoleTab, setSelectedRoleTab] = useState<any>(0);
	// const [openDefaultObjDrawer, setOpenDefaultObjDrawer] = useState<boolean>(false);
	// const [openDefaultKrDrawer, setOpenDefaultKrDrawer] = useState<any>({ open: false, details: null });
	const [selectedAssignTab, setSelectedAssignTab] = useState<any>(0);
	const [selectedDefaultKrTab, setSelectedDefaultKrTab] = useState<any>(0);
	const [allEmployeeChecked, setAllEmployeeChecked] = useState<boolean>(false);
	const [modalPerformanceProps, setModalPerformanceProps] = useState<any>({
		open: false,
		message: '',
		details: '',
		type: '',
	});
	const [showErrorMessageModal, setShowErrorMessageModal] = useState<any>({ open: false, message: '', details: '' });
	const [modalProps, setModalProps] = useState<any>({ open: false, message: '', details: '' });
	const [keyData, setKeyData] = useState<any>(null);
	const [krAttributeEdited, setKrAttributeEdited] = useState<boolean>(false);
	const [okrNameError, setOkrNameError] = useState<any>({ error: false, errorText: '' });
	const [okrRoleError, setOkrRoleError] = useState<any>({ error: false, errorText: '' });
	const [selectedOkrListCycleValue, setSelectedOkrListCycleValue] = useState<any>(null);

	useEffect(() => {
		if (allCycleDetails && allCycleDetails.cycleDetails && allCycleDetails.cycleDetails.length) {
			let currentQuarterDetails: any = getCycleDefaultSelection(allCycleDetails.cycleDetails, cycleId);
			if (currentQuarterDetails) {
				let defaultCycleDetails = selectedCycleDetailsInTab ? selectedCycleDetailsInTab : { ...currentQuarterDetails };
				if (mode !== 'Add') {
					const { startDate, endDate } = defaultOkrFormDetails || {};
					defaultCycleDetails.defaultStartDate = startDate;
					defaultCycleDetails.defaultEndDate = endDate;
				} else {
					defaultCycleDetails.defaultStartDate = null;
					defaultCycleDetails.defaultEndDate = null;
				}
				const updatedCycleDetails = {
					objectiveCycleId: defaultCycleDetails?.organisationCycleId || Enums.ZERO,
					year: defaultCycleDetails?.year || Enums.ZERO,
					startDate: defaultCycleDetails.defaultStartDate || defaultCycleDetails?.startDate || null,
					endDate: defaultCycleDetails.defaultEndDate || defaultCycleDetails?.endDate || null,
				};
				const { myGoalsDetails } = defaultOkrFormDetails;
				let updatedDefaultGoalKeys = updateKrDates(
					myGoalsDetails,
					defaultCycleDetails.defaultStartDate || defaultCycleDetails?.startDate || null,
					defaultCycleDetails.defaultEndDate || defaultCycleDetails?.endDate || null,
					defaultCycleDetails.defaultStartDate && defaultCycleDetails.defaultEndDate ? true : false
				);
				setDefaultOkrFormDetails({
					...defaultOkrFormDetails,
					...updatedCycleDetails,
					myGoalsDetails: updatedDefaultGoalKeys,
				});
				setSelectedCycleDetails(defaultCycleDetails);
				// setSelectedKrCycleDetails({ ...currentQuarterDetails });
				setIsCurrentCycle({ ...currentQuarterDetails });
				// setCurrentSelectedCycleYear(currentQuarterDetails?.year || currentCycleYear);
				// setCurrentCycleId(currentQuarterDetails?.organisationCycleId || currentCycleId);

				// const { startDate, endDate } = defaultCycleDetails;
				// setSelectedDateRange(moment().range(new Date(startDate), new Date(endDate)));
				if (mode === 'Add') {
					const { startDate, endDate } = defaultCycleDetails;
					setSelectedDateRange(moment().range(new Date(startDate), new Date(endDate)));
				} else {
					const { startDate, endDate } = defaultOkrFormDetails || {};
					if (startDate && endDate) {
						setSelectedDateRange(moment().range(new Date(startDate), new Date(endDate)));
					}
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [allCycleDetails]);
	useEffect(() => {
		if (selectedCycleDetails && selectedCycleDetails?.organisationCycleId) {
			const updatedCycleDetails = {
				objectiveCycleId: selectedCycleDetails?.organisationCycleId || Enums.ZERO,
				year: selectedCycleDetails?.year || Enums.ZERO,
				startDate: selectedCycleDetails?.defaultStartDate || selectedCycleDetails?.startDate || null,
				endDate: selectedCycleDetails?.defaultEndDate || selectedCycleDetails?.endDate || null,
			};
			const { myGoalsDetails } = defaultOkrFormDetails;
			let updatedDefaultGoalKeys = updateKrDates(
				myGoalsDetails,
				selectedCycleDetails?.defaultStartDate || selectedCycleDetails?.startDate || null,
				selectedCycleDetails?.defaultEndDate || selectedCycleDetails?.endDate || null,
				selectedCycleDetails.defaultStartDate && selectedCycleDetails?.defaultEndDate ? true : false
			);
			setDefaultOkrFormDetails({
				...defaultOkrFormDetails,
				...updatedCycleDetails,
				myGoalsDetails: updatedDefaultGoalKeys,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedCycleDetails]);
	// const getCycleDetailsForCreateEditOkr = () => {
	// 	const { status, objectiveCycleId } = defaultOkrFormDetails || {};
	// 	let updatedAllCycleDetails = { ...allCycleDetails } || {};
	// 	// if (status === Enums.TWO) {
	// 	let currentQuarterDetails: any = getCycleDefaultSelection(updatedAllCycleDetails.cycleDetails, objectiveCycleId);
	// 	if (currentQuarterDetails?.year) {
	// 		const cycleDetails =
	// 			updatedAllCycleDetails?.cycleDetails && updatedAllCycleDetails?.cycleDetails?.length
	// 				? [...updatedAllCycleDetails?.cycleDetails]
	// 				: [];
	// 		const selectedCycleIndex = cycleDetails.findIndex(
	// 			(cycleRec: any) => cycleRec.year === currentQuarterDetails?.year
	// 		);
	// 		let remainingCycles = cycleDetails.filter((rec: any, index: number) => index >= selectedCycleIndex);
	// 		remainingCycles = remainingCycles?.map((data: any) => {
	// 			const rec = { ...data };
	// 			rec.quarterDetails = rec?.quarterDetails.filter((q: any) => q?.organisationCycleId >= objectiveCycleId);
	// 			return rec;
	// 		});
	// 		updatedAllCycleDetails.cycleDetails = [...remainingCycles];
	// 	}
	// 	// }

	// 	return updatedAllCycleDetails;
	// };
	const updateKrDates = (myGoalsDetails: any, startDate: any, endDate: any, isDefaultDate: boolean) => {
		let updatedDefaultGoalKeys = [...myGoalsDetails]?.map((rec: any) => {
			return {
				...rec,
				startDate: isDefaultDate ? rec?.startDate || startDate || null : startDate || null,
				endDate: isDefaultDate ? rec?.endDate || endDate || null : endDate || null,
				dueDate: isDefaultDate ? rec?.endDate || endDate || null : endDate || null,
				isKrEdited: true,
			};
		});

		return updatedDefaultGoalKeys;
	};

	const handleBackButtonOnClick = () => {
		setDefaultOkrOpen(false);
		setTabSelected(1);
		setDefaultOkrFormDetails(defaultOkrDetailsObj);
		setEditDetails(null);
		setIsDefaultOkrFormEdited(false);
	};

	const handleDrawerOpen = (krItem: any, krIndex: any) => {
		setIsDefaultOkrFormEdited(false);
		setIsDefaultOkrFormEditedData({ krItem, krIndex });
		setOpenDefaultObjDrawer(true);
	};
	const handleKrDrawerOpen = (e: any, krItem: any, krIndex: number) => {
		setOpenDefaultKrDrawer({ open: true, details: { krItem, krIndex } });
		setIsDefaultOkrFormEdited(false);
	};
	const validateKrDrawerData = (krDetails: any) => {
		//Validate target and start value
		if (!krDetails?.keyDescription || krDetails?.keyDescription?.trim() === '') {
			const data = {
				isKrNameError: true,
				krNameErrorMsg: t('addKpiTitle'),
			};
			setKeyData({ ...keyData, ...data });

			return false;
		} else if (!krDetails.metricId) {
			const data = {
				isMetricTypeError: true,
				krMetricTypeErrorMsg: t('metricTypeRequired'),
				isMetricCurrencyError: false,
				krMetricCurrencyErrorMsg: '',
				isKrNameError: false,
				krNameErrorMsg: '',
			};
			setKeyData({ ...keyData, ...data });

			return false;
		} else if (krDetails.metricId === Enums.TWO && !krDetails?.currencyId) {
			const data = {
				isMetricTypeError: false,
				krMetricTypeErrorMsg: '',
				isMetricCurrencyError: true,
				krMetricCurrencyErrorMsg: t('currencyRequired'),
				isKrNameError: false,
				krNameErrorMsg: '',
			};
			setKeyData({ ...keyData, ...data });

			return false;
		}
		return true;
	};
	const deleteExtraRecord = (keyDetails: any) => {
		delete keyDetails.isMetricTypeError;
		delete keyDetails.krMetricTypeErrorMsg;
		delete keyDetails.isMetricCurrencyError;
		delete keyDetails.krMetricCurrencyErrorMsg;
		delete keyDetails.isKrNameError;
		delete keyDetails.krNameErrorMsg;
	};
	const handleKrDrawerClose = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
		try {
			if (type === 'save') {
				if (validateKrDrawerData(keyData)) {
					const { krIndex } = openDefaultKrDrawer?.details;
					const { myGoalsDetails } = defaultOkrFormDetails || {};
					let updatedDefaultGoalKeys = myGoalsDetails && myGoalsDetails?.length ? [...myGoalsDetails] : [];
					updatedDefaultGoalKeys = updatedDefaultGoalKeys.map((rec: any, indexVal: number) => {
						if (krIndex === indexVal) {
							if (keyData) {
								deleteExtraRecord(keyData);

								return {
									...keyData,
									isKrEdited: true,
								};
							} else {
								deleteExtraRecord(rec);

								return { ...rec };
							}
						} else {
							deleteExtraRecord(rec);

							return { ...rec };
						}
					});
					setDefaultOkrFormDetails({
						...defaultOkrFormDetails,
						myGoalsDetails: [...updatedDefaultGoalKeys],
					});
					setKrAttributeEdited(false);
					setIsDefaultOkrFormEdited(true);
					setOpenDefaultKrDrawer({ open: false, details: null });
				}
			} else if (type === 'close' || type === 'cancel') {
				if (krAttributeEdited) {
					// Need to show unSave popup
					setModalPerformanceProps({ open: true, message: t('unSavedItemAlert'), details: '', type: 'KrAttribute' });
				} else {
					setIsDefaultOkrFormEdited(true);
					setOpenDefaultKrDrawer({ open: false, details: null });
					setKrAttributeEdited(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handlePerformanceCloseModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalPerformanceProps?.type === 'KrAttribute') {
				setKeyData(null);
				setIsDefaultOkrFormEdited(true);
				setOpenDefaultKrDrawer({ open: false, message: '', details: null });
			} else if (modalPerformanceProps?.type === 'OKR') {
				setOpenDefaultObjDrawer(false);
				setIsDefaultOkrFormEdited(true);
				setSelectedDesignationOptions([]);
				setSelectedPerformanceRoleOptions([]);
				setSelectedUsersOptions([]);
				setAllEmployeeChecked(false);
				setDefaultOkrFormEdited(false);
				setIsDefaultOkrFormEditedData(null);
				setSelectedRoleTab(0);
			} else if (modalPerformanceProps?.type === 'KrWeightToggleChange') {
				const { checked, krItem, krIndex } = modalPerformanceProps?.details || {};
				if (krItem) {
					updateIsWeightSameToggleDetails(checked, krItem, krIndex);
				}
			} else if (modalPerformanceProps?.type === 'KrTargetToggleChange') {
				const { checked, krItem, krIndex } = modalPerformanceProps?.details || {};
				if (krItem) {
					updateIsTargetSameToggleDetails(checked, krItem, krIndex);
				}
			} else if (modalPerformanceProps?.type === 'ROLE') {
				const { item, indexVal, deleteType, assignType } = modalPerformanceProps?.details || {};
				if (assignType === Enums.ONE) {
					let updatedList = [...selectedDesignationOptions];
					updatedList = updatedList.filter((rec: any) => !item?.find((role: any) => role?.value === rec.value));
					setSelectedDesignationOptions(updatedList);
				} else if (assignType === Enums.TWO) {
					let updatedList = [...selectedPerformanceRoleOptions];
					updatedList = updatedList.filter((rec: any) => !item?.find((role: any) => role?.value === rec.value));
					setSelectedPerformanceRoleOptions(updatedList);
				} else if (assignType === Enums.THREE) {
					let updatedList = [...selectedUsersOptions];
					updatedList = updatedList.filter((rec: any) => !item?.find((role: any) => role?.value === rec.value));
					setSelectedUsersOptions(updatedList);
				}
				setIsDefaultOkrFormEdited(true);
			} else if (modalPerformanceProps?.type === 'OKRDelete') {
				handleBackButtonOnClick();
				dispatch(setShowKpiCreateOpen(false));
			} else if (modalPerformanceProps?.type === 'KRDelete') {
				const { item, indexValue } = modalPerformanceProps?.details;

				if (mode === 'Add' || !item?.goalKeyId) {
					// remove locally
				} else {
					deleteDefaultOkr(item?.goalKeyId, 'KR');
				}
				const { myGoalsDetails } = defaultOkrFormDetails;
				if (myGoalsDetails && myGoalsDetails?.length) {
					const updatedDefaultGoalKeys = myGoalsDetails.filter(
						(rec: any, itemIndex: number) => itemIndex !== indexValue
					);
					setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: updatedDefaultGoalKeys });
					setIsDefaultOkrFormEdited(true);
				}
			} else if (modalPerformanceProps?.type === 'DefaultOKR') {
				deleteDefaultOkr(modalPerformanceProps?.details?.okrDetails?.goalObjectiveId, 'OKR');
			}

			setModalPerformanceProps({ open: false, message: '', details: '', type: '' });
		} else {
			setModalPerformanceProps({ open: false, message: '', details: '', type: '' });
		}
	};
	const handleTabChange = (event: React.ChangeEvent<HTMLInputElement>, newValue: Number) => {
		event.preventDefault();
		// setSelectedAssignTab(newValue);
		setSelectedDefaultKrTab(newValue);
	};
	/**
	 *
	 */
	const handleOkrDeletionClick = (event: any, okrDetails: any) => {
		try {
			if (mode !== 'Add') {
				if (okrDetails?.status === Enums.ONE) {
					let msg = '';
					const goalKeys =
						okrDetails?.myGoalsDetails && okrDetails?.myGoalsDetails?.length
							? okrDetails?.myGoalsDetails?.filter((item: any) => item.keyDescription)
							: [];
					if (goalKeys?.length === Enums.ZERO) {
						msg = t('deleteKpiCategoryMessage');
					} else if (goalKeys?.length) {
						msg = t('deleteListingKpiCatMessage');
					}
					setModalPerformanceProps({
						open: true,
						message: msg,
						type: 'DefaultOKR',
						details: { okrDetails: okrDetails, deleteType: 'DefaultOKR' },
						event: event,
					});
				} else {
					setModalProps({
						open: true,
						message: '',
						module: 'confirmation',
						details: {
							deleteType: 'OKR',
							headingText: t('deleteKpiCategoryMessage'),
							okrDetails,
							//subHeading: t('deletePerformanceCycleSubHead'),
							//matchString: Enums.DELETE_TEXT,
						},
					});
				}
			} else {
				setModalPerformanceProps({
					open: true,
					message: t('deleteKpiCategoryMessage'),
					details: '',
					type: 'OKRDelete',
				});
				// handleBackButtonOnClick();
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleKRDeletionClick = (event: any, krItem: any, krIndex: number) => {
		try {
			if (mode !== 'Add') {
				setModalProps({
					open: true,
					message: '',
					module: 'confirmation',
					details: {
						deleteType: 'KR',
						headingText: t('deleteKpiMessage'),
						item: krItem,
						indexValue: krIndex,
					},
				});
			} else {
				setModalPerformanceProps({
					open: true,
					message: t('deleteKpiMessage'),
					details: {
						item: krItem,
						indexValue: krIndex,
					},
					type: 'KRDelete',
				});
			}
		} catch (error) {
			console.error(error);
		}
	};
	/** */
	const updateIsWeightSameToggleDetails = (checked: boolean, krItem: any, krIndex: number) => {
		const { myGoalsDetails } = defaultOkrFormDetails;
		let updatedDefaultGoalKeys = [...myGoalsDetails];
		updatedDefaultGoalKeys[krIndex].isWeightSame = checked;
		updatedDefaultGoalKeys[krIndex].defaultGoalKeyAssignMappings =
			updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings &&
			updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.length
				? updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.map((role: any) => {
						role.weight = checked ? krItem.weight : Enums.ONE;

						return role;
				  })
				: [];
		setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...updatedDefaultGoalKeys] });
		setIsDefaultOkrFormEdited(true);
	};
	const handleIsWeightSameToggleClick = (event: any, krItem: any, krIndex: number) => {
		try {
			const { checked } = event?.target;
			if (mode === 'Edit' && defaultOkrFormDetails?.status === Enums.TWO && krItem?.goalKeyId) {
				setModalPerformanceProps({
					open: true,
					message: t('changeWeightOrTargetToggle'),
					details: {
						checked,
						krItem,
						krIndex,
					},
					type: 'KrWeightToggleChange',
				});
			} else {
				if (krItem) {
					updateIsWeightSameToggleDetails(checked, krItem, krIndex);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const updateIsTargetSameToggleDetails = (checked: boolean, krItem: any, krIndex: number) => {
		const { myGoalsDetails } = defaultOkrFormDetails;
		let updatedDefaultGoalKeys = [...myGoalsDetails];
		updatedDefaultGoalKeys[krIndex].isTargetSame = checked;
		updatedDefaultGoalKeys[krIndex].isTargetValueError = false;
		updatedDefaultGoalKeys[krIndex].krTargetValueErrorMsg = false;
		updatedDefaultGoalKeys[krIndex].defaultGoalKeyAssignMappings =
			updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings &&
			updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.length
				? updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.map((role: any) => {
						role.startValue = checked ? krItem.startValue : Enums.ZERO;
						role.targetValue = checked ? krItem.targetValue : Enums.ZERO;
						role.isRoleTargetValueError = false;
						role.roleTargetValueErrorMsg = '';

						return role;
				  })
				: [];
		setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...updatedDefaultGoalKeys] });
		setIsDefaultOkrFormEdited(true);
	};
	const handleIsTargetSameToggleClick = (event: any, krItem: any, krIndex: number) => {
		try {
			const { checked } = event?.target;
			if (mode === 'Edit' && defaultOkrFormDetails?.status === Enums.TWO && krItem?.goalKeyId) {
				setModalPerformanceProps({
					open: true,
					message: t('changeWeightOrTargetToggle'),
					details: {
						checked,
						krItem,
						krIndex,
					},
					type: 'KrTargetToggleChange',
				});
			} else {
				updateIsTargetSameToggleDetails(checked, krItem, krIndex);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleKrStartTargetValueChange = (event: any, krItem: any, krIndex: number, keyName: string) => {
		try {
			const { value } = event?.target;
			const regexp = /^[0-9\\.b]+$/;
			if (value === '' || regexp.test(value)) {
				let newValue = !Boolean(value) ? '0' : value;
				const { myGoalsDetails } = defaultOkrFormDetails;
				let updatedDefaultGoalKeys = [...myGoalsDetails];
				updatedDefaultGoalKeys[krIndex][keyName] = parseInt(newValue);
				updatedDefaultGoalKeys[krIndex].isTargetValueError = false;
				updatedDefaultGoalKeys[krIndex].krTargetValueErrorMsg = '';
				updatedDefaultGoalKeys[krIndex].defaultGoalKeyAssignMappings =
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings &&
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.length
						? updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.map((role: any) => {
								role[keyName] = krItem?.isTargetSame ? parseInt(newValue) : role[keyName];
								role.isRoleTargetValueError = false;
								role.roleTargetValueErrorMsg = '';

								return role;
						  })
						: [];
				setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...updatedDefaultGoalKeys] });
				setIsDefaultOkrFormEdited(true);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleKrRoleStartTargetValueChange = (
		event: any,
		krItem: any,
		krIndex: number,
		roleItem: any,
		roleIndex: number,
		keyName: string
	) => {
		try {
			const { value } = event?.target;
			const regexp = /^[0-9\\.b]+$/;
			if (value === '' || regexp.test(value)) {
				let newValue = !Boolean(value) ? '0' : value;
				// console.log('handleKrRoleStartTargetValueChange ===> ', newValue, krItem, krIndex);
				const { myGoalsDetails } = defaultOkrFormDetails;
				let updatedDefaultGoalKeys = [...myGoalsDetails];
				updatedDefaultGoalKeys[krIndex].defaultGoalKeyAssignMappings =
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings &&
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.length
						? updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.map((roleVal: any, indexVal: number) => {
								if (indexVal === roleIndex) {
									roleVal[keyName] = parseInt(newValue);
									roleVal.isRoleTargetValueError = false;
									roleVal.roleTargetValueErrorMsg = '';
								}

								return roleVal;
						  })
						: [];
				setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...updatedDefaultGoalKeys] });
				setIsDefaultOkrFormEdited(true);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleWeightUpdate = (selectedWeightDetails: any, selectedWeight: number) => {
		try {
			const { details, type } = selectedWeightDetails || {};
			const { myGoalsDetails } = defaultOkrFormDetails;
			if (type === 'KrWeight') {
				const { krItem, krIndex } = details || {};
				let updatedDefaultGoalKeys = [...myGoalsDetails];
				const checked = updatedDefaultGoalKeys[krIndex].isWeightSame;
				updatedDefaultGoalKeys[krIndex].weight = selectedWeight;
				updatedDefaultGoalKeys[krIndex].defaultGoalKeyAssignMappings =
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings &&
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.length
						? updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.map((role: any) => {
								role.weight = checked ? selectedWeight : Enums.ONE;

								return role;
						  })
						: [];
				setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...updatedDefaultGoalKeys] });
			} else if (type === 'KrRoleWeight') {
				const { krItem, krIndex, role, roleIndex } = details || {};
				let updatedDefaultGoalKeys = [...myGoalsDetails];
				updatedDefaultGoalKeys[krIndex].defaultGoalKeyAssignMappings =
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings &&
					updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.length
						? updatedDefaultGoalKeys[krIndex]?.defaultGoalKeyAssignMappings?.map((roleVal: any, indexVal: number) => {
								if (indexVal === roleIndex) {
									roleVal.weight = selectedWeight || Enums.ONE;
								}

								return roleVal;
						  })
						: [];
				setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...updatedDefaultGoalKeys] });
			}
			setIsDefaultOkrFormEdited(true);
		} catch (error) {}
	};
	/** */
	const handleObjectiveNameChange = (event: any) => {
		try {
			const { name, value } = event?.target || {};
			if (name) {
				setDefaultOkrFormDetails({ ...defaultOkrFormDetails, [name]: value });
				setOkrNameError({ error: false, errorText: '' });
				setIsDefaultOkrFormEdited(true);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleKrExpandCollapse = (krItem: any, krIndex: number) => {
		try {
			let krListDetails =
				defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails.length
					? defaultOkrFormDetails?.myGoalsDetails
					: [];
			krListDetails = krListDetails.map((kr: any, index: number) => {
				if (index === krIndex) {
					kr.isExpand = !kr?.isExpand;
				}
				//  else {
				// 	kr.isExpand = false;
				// }
				return kr;
			});

			setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...krListDetails] });
		} catch (error) {
			console.error(error);
		}
	};
	const handleKrRoleSort = (column: string, updatedRoleList: any, krItem: any, krIndex: number) => {
		// sortColumn
		let krListDetails =
			defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails.length
				? defaultOkrFormDetails?.myGoalsDetails
				: [];
		krListDetails[krIndex].defaultGoalKeyAssignMappings = updatedRoleList;
		krListDetails[krIndex].krSortColumn = column;
		setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...krListDetails] });
	};
	const handleKrRoleSearch = (value = '', searchType: string, krItem: any, krIndex: number) => {
		try {
			let krListDetails =
				defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails.length
					? defaultOkrFormDetails?.myGoalsDetails
					: [];
			if (krListDetails && krListDetails.length) {
				if (searchType === 'insert') {
					krListDetails[krIndex].searchTextValueForKrRole = value;
				} else if (searchType === 'search') {
					krListDetails[krIndex].searchTextValueForKrRole = '';
					krListDetails[krIndex].searchTextForKrRole = value;
				} else if (searchType === 'clear') {
					krListDetails[krIndex].searchTextValueForKrRole = '';
					krListDetails[krIndex].searchTextForKrRole = '';
				}
				setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...krListDetails] });
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleKrNameChange = (event: any, krItem: any, krIndex: number) => {
		try {
			const { value } = event?.target || {};
			let krListDetails =
				defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails.length
					? [...defaultOkrFormDetails?.myGoalsDetails]
					: [];
			if (krListDetails && krListDetails.length) {
				krListDetails[krIndex].keyDescription = value;
				krListDetails[krIndex].isKrEdited = true;
				krListDetails[krIndex].isKrNameError = false;
				krListDetails[krIndex].krNameErrorMsg = '';
				if (value && value?.trim() !== '' && noBlankKrAvailable(krListDetails)) {
					insertNewKrRow(krListDetails);
				} else {
					setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...krListDetails] });
				}
			} else {
				insertNewKrRow([]);
			}
			setIsDefaultOkrFormEdited(true);
		} catch (error) {
			console.error(error);
		}
	};

	const handleKrProgressChange = (event: any, krItem: any, krIndex: number, value: any) => {
		try {
			const { value } = event?.target || {};
			let krListDetails =
				defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails.length
					? defaultOkrFormDetails?.myGoalsDetails
					: [];
			if (krListDetails && krListDetails.length) {
				krListDetails[krIndex].isKrEdited = true;
				krListDetails[krIndex].scoreValue = value;
				krListDetails[krIndex].krNameErrorMsg = '';
			} else {
			}
			setIsDefaultOkrFormEdited(true);
		} catch (error) {
			console.error(error);
		}
	};
	const noBlankKrAvailable = (krListDetails: any) => {
		const krItem = krListDetails?.find(
			(item: any) => item?.keyDescription === '' || (item.keyDescription && item.keyDescription.trim() === '')
		);

		return krItem ? false : true;
	};
	const insertNewKrRow = (krListDetails: any) => {
		const { assignIds, goalObjectiveId, assignType } = defaultOkrFormDetails || {};

		setDefaultOkrFormDetails({
			...defaultOkrFormDetails,
			myGoalsDetails: [
				...krListDetails,
				{
					...defaultGoalKeyObject,
					startDate: selectedCycleDetails?.defaultStartDate || selectedCycleDetails?.startDate,
					endDate: selectedCycleDetails?.defaultEndDate || selectedCycleDetails?.endDate,
					dueDate: selectedCycleDetails?.defaultEndDate || selectedCycleDetails?.endDate,
				},
			],
		});
	};
	const handleUpdateAssignIds = (assignIdsDetails: any, assignType: number, krIndex = -1) => {
		try {
			const { myGoalsDetails } = defaultOkrFormDetails || {};
			const updatedAssignIds =
				assignType === Enums.FOUR
					? assignIdsDetails
					: assignIdsDetails && assignIdsDetails?.length
					? assignIdsDetails.map((item: any) => {
							const rec = { ...item };
							let extraParamForUser = {};
							if (assignType === Enums.THREE) {
								extraParamForUser = {
									firstName: item?.firstName || '',
									lastName: item?.lastName || '',
									employeeId: item?.employeeId || '',
									imagePath: item?.imagePath || '',
									emailId: item?.emailId || '',
									isActive: item?.isActive,
								};
							}
							return {
								...extraParamForUser,
								defaultGoalObjectiveAssignMappingId: Enums.ZERO,
								assignId: rec?.value || Enums.ZERO,
								name: rec?.label || '',
								userCount: rec?.userCount || Enums.ZERO,
							};
					  })
					: [];
			let updatedDefaultGoalKeys = [...myGoalsDetails]?.map((rec: any, recIndex: number) => {
				if (krIndex !== -1 && krIndex === recIndex) {
					const updatedDefaultGoalKeyAssignMappings =
						updatedAssignIds && updatedAssignIds?.length
							? updatedAssignIds?.map((item: any) => {
									let findData = null;
									if (defaultOkrFormDetails?.assignType === assignType) {
										findData = rec?.defaultGoalKeyAssignMappings.find((re: any) => re?.assignId === item?.assignId);
									}

									return {
										...item,
										defaultGoalKeyAssignMappingId: Enums.ZERO,
										// assignId: item?.assignId || Enums.ZERO,
										goalKeyId: defaultOkrFormDetails?.goalObjectiveId || Enums.ZERO,
										// defaultGoalObjectiveAssignMappingId: item?.defaultGoalObjectiveAssignMappingId || Enums.ZERO,
										weight: rec?.isWeightSame ? rec?.weight : findData?.weight || Enums.ONE,
										startValue: rec?.isTargetSame ? rec?.startValue : findData?.startValue || Enums.ZERO,
										targetValue: rec?.isTargetSame ? rec?.targetValue : findData?.targetValue || Enums.ZERO,
									};
							  })
							: [];
					return {
						...rec,
						isKrEdited: true,
						assignType,
						okrRoleError: false,
						okrRoleErrorText: '',
						defaultGoalKeyAssignMappings: [...updatedDefaultGoalKeyAssignMappings],
					};
				} else {
					return {
						...rec,
					};
				}
			});

			setDefaultOkrFormDetails({
				...defaultOkrFormDetails,
				assignType,
				assignIds: updatedAssignIds,
				selectedListDetails: assignIdsDetails && assignIdsDetails?.length ? assignIdsDetails : [],
				myGoalsDetails: [...updatedDefaultGoalKeys],
			});
			setSelectedDesignationOptions([]);
			setSelectedPerformanceRoleOptions([]);
			setSelectedUsersOptions([]);
			setAllEmployeeChecked(false);
		} catch (error) {
			console.error(error);
		}
	};
	const handleAllEmployeeSelection = (allEmpChecked: boolean) => {
		try {
			setAllEmployeeChecked(allEmpChecked || false);
			setSelectedDesignationOptions([]);
			setSelectedPerformanceRoleOptions([]);
			setSelectedUsersOptions([]);
			setDefaultOkrFormEdited(true);
		} catch (error) {}
	};
	const handleSelectedRoleDeletion = (
		event: any, // button event
		item: any, // array for single or bulk
		indexVal: number, // item index for single item
		deleteType: string, // single bulk
		assignType: number // 1 2 3
	) => {
		if (defaultOkrFormDetails?.status !== Enums.TWO) {
			setModalPerformanceProps({
				open: true,
				message: t('selectedRecordsDelete'),
				details: {
					headingText: t('assignRoleDelete'),
					subHeading: ' ',
					matchString: Enums.DELETE_TEXT,
					item,
					indexVal,
					deleteType: 'ROLE',
					assignType,
				},
				type: 'ROLE',
			});
		} else {
			setModalProps({
				open: true,
				message: '',
				module: 'confirmation',
				details: {
					headingText: t('assignRoleDelete'),
					subHeading: ' ',
					matchString: Enums.DELETE_TEXT,
					item,
					indexVal,
					deleteType: 'ROLE',
					assignType,
				},
			});
		}
	};
	const deleteDefaultOkr = async (deletionId: any, deleteType: string) => {
		try {
			if (deletionId) {
				setShowLoader(true);
				const isGoalObjective = deleteType === 'OKR' ? true : false;
				const requestParams = `id=${deletionId}&isGoalObjective=${isGoalObjective}`;
				const response: any = await dispatch(defaultOkrDelete(requestParams));
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					// defaultOkrAPICall();
					if (deleteType === 'OKR') {
						handleBackButtonOnClick();
					} else {
						setShowLoader(false);
					}
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					showApiMsg('error', messages || t('FetchingDefaultOkrError'));
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleConfirmationCloseModal = async (e: any, type: any) => {
		try {
			// e.preventDefault();
			if (type === 1) {
				const { details } = modalProps || {};
				if (details && details?.deleteType === 'OKR') {
					if (mode === 'Add') {
						handleBackButtonOnClick();
					} else {
						deleteDefaultOkr(details?.okrDetails?.goalObjectiveId, details?.deleteType);
					}
				} else if (details && details?.deleteType === 'KR') {
					const { item, indexValue } = details;
					if (mode === 'Add' || !item?.goalKeyId) {
						// console.log(item, indexValue);
						// remove locally
					} else {
						deleteDefaultOkr(item?.goalKeyId, details?.deleteType);
					}
					const { myGoalsDetails } = defaultOkrFormDetails;
					if (myGoalsDetails && myGoalsDetails?.length) {
						const updatedDefaultGoalKeys = myGoalsDetails.filter(
							(rec: any, itemIndex: number) => itemIndex !== indexValue
						);
						setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: updatedDefaultGoalKeys });
						setIsDefaultOkrFormEdited(true);
					}
				} else if (details && details?.deleteType === 'OKRCycleChange') {
					const { range, start, end, selCycleData } = details;
					if (range) {
						setSelectedDateRange(range);
						// setSelectedKrDateRange(range);
						const updatedCycleDetails = {
							objectiveCycleId: selectedCycleDetails?.organisationCycleId || Enums.ZERO,
							year: selectedCycleDetails?.year || Enums.ZERO,
							startDate: start || null,
							endDate: end || null,
						};
						const { myGoalsDetails } = defaultOkrFormDetails;
						let updatedDefaultGoalKeys = updateKrDates(myGoalsDetails, start, end, false);
						setDefaultOkrFormDetails({
							...defaultOkrFormDetails,
							...updatedCycleDetails,
							myGoalsDetails: [...updatedDefaultGoalKeys],
						});

						setSelectedCycle({
							organisationCycleId: selCycleData?.organisationCycleId || 0,
							currentCycleYear: selCycleData?.year || '',
							cycleDuration: cycleDuration || '',
						});
						setSelectedOkrListCycleValue({
							...selCycleData,
						});
						setIsDefaultOkrFormEdited(true);
					}
				} else if (details && details?.deleteType === 'ROLE') {
					const { item, indexVal, deleteType, assignType } = details || {};
					if (assignType === Enums.ONE) {
						let updatedList = [...selectedDesignationOptions];
						updatedList = updatedList.filter((rec: any) => !item?.find((role: any) => role?.value === rec.value));
						setSelectedDesignationOptions(updatedList);
					} else if (assignType === Enums.TWO) {
						let updatedList = [...selectedPerformanceRoleOptions];
						updatedList = updatedList.filter((rec: any) => !item?.find((role: any) => role?.value === rec.value));
						setSelectedPerformanceRoleOptions(updatedList);
					} else if (assignType === Enums.THREE) {
						let updatedList = [...selectedUsersOptions];
						updatedList = updatedList.filter((rec: any) => !item?.find((role: any) => role?.value === rec.value));
						setSelectedUsersOptions(updatedList);
					}
					setIsDefaultOkrFormEdited(true);
				}
				setModalProps({ open: false, message: '', details: '' });
			} else {
				const { details } = modalProps || {};
				if (details && details?.deleteType === 'OKRCycleChange') {
					const { prevSelection } = details;
					if (prevSelection) {
						setSelectedCycleDetails(prevSelection);
					}
				}
				setModalProps({ open: false, message: '', details: '' });
			}
		} catch (error) {
			console.error(error);
		}
	};
	const validateDraftForm = (type = 1) => {
		if (type === Enums.ONE) {
			if (!defaultOkrFormDetails?.kpiCategoryMasterId) {
				setOkrNameError({ error: true, errorText: t('addKpiCatTitle') });
				return false;
			} else {
				const { myGoalsDetails } = defaultOkrFormDetails || {};
				let updatedErrorMessage = myGoalsDetails && myGoalsDetails?.length ? [...myGoalsDetails] : [];
				let lastUpdatedErrorMessage: any[] = [];
				if (myGoalsDetails.length > 1) {
					lastUpdatedErrorMessage = updatedErrorMessage.splice(-1); // to remove last blank kr
				}
				let isErrorUpdate: boolean = false;
				updatedErrorMessage = updatedErrorMessage.map((it: any) => {
					let data = { ...it };
					if (!data?.keyDescription || data?.keyDescription?.trim() === '') {
						isErrorUpdate = true;
						data = { ...data, isExpand: true, isKrNameError: true, krNameErrorMsg: t('addKpiTitle') };
					} else {
						data = { ...data, isKrNameError: false, krNameErrorMsg: '' };
					}
					return data;
				});

				setDefaultOkrFormDetails({
					...defaultOkrFormDetails,
					myGoalsDetails: [...updatedErrorMessage, ...lastUpdatedErrorMessage],
				});

				return !isErrorUpdate;
			}
		} else if (type === Enums.TWO || type === Enums.THREE) {
			if (!defaultOkrFormDetails?.name || defaultOkrFormDetails?.name?.trim() === '') {
				setOkrNameError({ error: true, errorText: t('addKpiCatTitle') });
				return false;
			} else if (defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails?.length > 1) {
				const { myGoalsDetails } = defaultOkrFormDetails || {};
				let updatedErrorMessage = myGoalsDetails && myGoalsDetails?.length ? [...myGoalsDetails] : [];
				const lastUpdatedErrorMessage = updatedErrorMessage.splice(-1); // to remove last blank kr
				let isErrorUpdate: boolean = false;
				updatedErrorMessage = updatedErrorMessage.map((it: any) => {
					let data = { ...it };
					if (!data?.keyDescription || data?.keyDescription?.trim() === '') {
						isErrorUpdate = true;
						data = { ...data, isExpand: true, isKrNameError: true, krNameErrorMsg: t('addKpiTitle') };
					} else {
						data = { ...data, isKrNameError: false, krNameErrorMsg: '' };
					}
					if (!data.metricId) {
						isErrorUpdate = true;
						data = {
							...data,
							isExpand: true,
							isMetricTypeError: true,
							krMetricTypeErrorMsg: t('metricTypeRequired'),
							isMetricCurrencyError: false,
							krMetricCurrencyErrorMsg: '',
						};
					} else if (data.metricId === Enums.TWO && !data?.currencyId) {
						isErrorUpdate = true;
						data = {
							...data,
							isExpand: true,
							isMetricTypeError: false,
							krMetricTypeErrorMsg: '',
							isMetricCurrencyError: true,
							krMetricCurrencyErrorMsg: t('currencyRequired'),
						};
					}
					if (data?.isTargetSame && !data.targetValue && !data.startValue) {
						isErrorUpdate = true;
						data = {
							...data,
							isExpand: true,
							isTargetValueError: true,
							krTargetValueErrorMsg: t('targetValueRequired'),
						};
					} else if (data?.isTargetSame && data.targetValue === data.startValue) {
						isErrorUpdate = true;

						data = {
							...data,
							isExpand: true,
							isTargetValueError: true,
							krTargetValueErrorMsg: t('startTargetNotSame'),
						};
					} else {
						data = { ...data, isTargetValueError: false, krTargetValueErrorMsg: '' };
					}

					return data;
				});

				setDefaultOkrFormDetails({
					...defaultOkrFormDetails,
					myGoalsDetails: [...updatedErrorMessage, ...lastUpdatedErrorMessage],
				});

				return !isErrorUpdate;
			} else if (defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails?.length === 1) {
				const { myGoalsDetails } = defaultOkrFormDetails || {};
				let updatedErrorMessage = myGoalsDetails && myGoalsDetails?.length ? [...myGoalsDetails] : [];
				updatedErrorMessage = updatedErrorMessage.map((it: any) => {
					let data = { ...it };
					if (!data?.keyDescription || data?.keyDescription?.trim() === '') {
						data = { ...data, isKrNameError: true, krNameErrorMsg: t('addKpiTitle') };
					} else {
						data = { ...data, isKrNameError: false, krNameErrorMsg: '' };
					}
					if (!data.defaultGoalKeyAssignMappings || data.defaultGoalKeyAssignMappings.length === 0) {
						data = {
							...data,
							isExpand: true,
							okrRoleError: true,
							okrRoleErrorText: t('roleRequiredAlertMssg'),
						};
					} else {
						data = {
							...data,
							okrRoleError: false,
							okrRoleErrorText: '',
						};
					}
					if (!data.metricId) {
						data = {
							...data,
							isMetricTypeError: true,
							krMetricTypeErrorMsg: t('metricTypeRequired'),
							isMetricCurrencyError: false,
							krMetricCurrencyErrorMsg: 'false',
						};
					} else if (data.metricId === Enums.TWO && !data?.currencyId) {
						data = {
							...data,
							isMetricTypeError: false,
							krMetricTypeErrorMsg: '',
							isMetricCurrencyError: true,
							krMetricCurrencyErrorMsg: t('currencyRequired'),
						};
					}
					if (!data.targetValue) {
						data = { ...data, isTargetValueError: true, krTargetValueErrorMsg: t('targetValueRequired') };
					} else if (data.targetValue === data.startValue) {
						data = {
							...data,
							isTargetValueError: true,
							krTargetValueErrorMsg: t('startTargetNotSame'),
						};
					} else {
						data = { ...data, isTargetValueError: false, krTargetValueErrorMsg: '' };
					}

					return data;
				});

				setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: [...updatedErrorMessage] });

				return false;
			}
		} else {
			return true;
		}
	};
	const handleDraftDefaultOkrClick = async (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			if (validateDraftForm(Enums.ONE)) {
				setShowLoader(true);
				setOkrNameError({ error: false, errorText: '' });
				setOkrRoleError({ error: false, errorText: '' });
				let requestPayload = {
					...defaultOkrFormDetails,
					natureTypeId: Enums.TWO,
					goalStatusId: Enums.ONE,
					isUpdatedNotPublished: false,
					myGoalsDetails:
						defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails?.length
							? defaultOkrFormDetails?.myGoalsDetails
									?.filter((rec: any) => rec?.keyDescription || rec?.keyDescription?.trim() !== '')
									.map((rec: any) => {
										return {
											...rec,
											status: Enums.ONE,
											isUpdatedNotPublished: false,
											goalStatusId: Enums.ONE,
											krStatusId: Enums.FOUR,
										};
									})
							: [],
				};
				// Need to check KR Status based on isKrEdited flag
				delete requestPayload.selectedListDetails;
				// console.log('handleDraftDefaultOkrClick ===>', requestPayload);
				let response: any = null;
				if (mode === 'Add') {
					response = await dispatch(createDefaultKpi([requestPayload]));
				} else if (mode === 'Edit') {
					response = await dispatch(editDefaultKpi([requestPayload]));
				}
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					// NEED TO UPDATE
					setHighlightDefaultOkr(response?.data?.entity?.goalObjectiveId);

					selectedOkrListCycleValue && setSelectedOkrListCycleDetails(selectedOkrListCycleValue);
					handleBackButtonOnClick();
					showApiMsgs(response?.data?.messageList.Result, 'success');

					dispatch(setKpiListReload(true));
					dispatch(setShowKpiCreateOpen(false));
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					enqueueSnackbar(messages || t('savingDraftError'), {
						variant: 'error',
						autoHideDuration: 3000,
					});
				}
				setIsDefaultOkrFormEdited(false);
				setShowLoader(false);
			}
		} catch (error) {
			console.error(error);
			enqueueSnackbar(t('savingDraftError'), {
				variant: 'error',
				autoHideDuration: 3000,
			});
			setShowLoader(false);
		}
	};
	const handleSaveAndPublishLaterDefaultOkrClick = async (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			if (validateDraftForm(Enums.TWO)) {
				// console.log('handleSaveAndPublishLaterDefaultOkrClick ===>', defaultOkrFormDetails);
				setShowLoader(true);
				setOkrNameError({ error: false, errorText: '' });
				setOkrRoleError({ error: false, errorText: '' });
				const statusVal =
					defaultOkrFormDetails?.goalStatusId === Enums.TWO || defaultOkrFormDetails?.goalStatusId === Enums.FOUR
						? Enums.FOUR
						: Enums.THREE;
				const requestPayload = {
					...defaultOkrFormDetails,
					natureTypeId: Enums.TWO,
					status: statusVal,
					isUpdatedNotPublished:
						defaultOkrFormDetails?.goalStatusId === Enums.TWO || defaultOkrFormDetails?.goalStatusId === Enums.FOUR
							? true
							: false,
					myGoalsDetails:
						defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails?.length
							? defaultOkrFormDetails?.myGoalsDetails
									?.filter((rec: any) => rec?.keyDescription || rec?.keyDescription?.trim() !== '')
									.map((rec: any) => {
										return {
											...rec,
											goalStatusId: statusVal,
											krStatusId:
												defaultOkrFormDetails?.goalStatusId === Enums.TWO ||
												defaultOkrFormDetails?.goalStatusId === Enums.FOUR
													? Enums.FOUR
													: Enums.THREE,
											isUpdatedNotPublished:
												defaultOkrFormDetails?.goalStatusId === Enums.TWO ||
												defaultOkrFormDetails?.goalStatusId === Enums.FOUR
													? true
													: false,
										};
									})
							: [],
				};
				// Need to check KR Status based on isKrEdited flag
				delete requestPayload.selectedListDetails;
				// console.log('handleSaveAndPublishLaterDefaultOkrClick ===>', requestPayload);
				// /*
				let response: any = null;
				if (mode === 'Add') {
					response = await dispatch(createDefaultKpi([requestPayload]));
				} else if (mode === 'Edit') {
					response = await dispatch(editDefaultKpi([requestPayload]));
				}
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					// NEED TO UPDATE
					setHighlightDefaultOkr(response?.data?.entity?.goalObjectiveId);
					selectedOkrListCycleValue && setSelectedOkrListCycleDetails(selectedOkrListCycleValue);
					handleBackButtonOnClick();
					dispatch(setKpiListReload(true));
					dispatch(setShowKpiCreateOpen(false));
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					enqueueSnackbar(messages || t('savingDraftError'), {
						variant: 'error',
						autoHideDuration: 3000,
					});
				}
				// */
				setIsDefaultOkrFormEdited(false);
				setShowLoader(false);
			}
		} catch (error) {
			console.error(error);
			enqueueSnackbar(t('savingDraftError'), {
				variant: 'error',
				autoHideDuration: 3000,
			});
			setShowLoader(false);
		}
	};
	const showApiMsgs = (msg: string, variant: any) => {
		enqueueSnackbar(msg, {
			variant: variant,
			autoHideDuration: 5000,
		});
	};
	const handlePublishDefaultOkrClick = async (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			console.log('defaultOkrFormDetails', defaultOkrFormDetails);
			if (validateDraftForm(Enums.TWO)) {
				// console.log('handlePublishDefaultOkrClick ===>', defaultOkrFormDetails);
				setShowLoader(true);
				setOkrNameError({ error: false, errorText: '' });
				setOkrRoleError({ error: false, errorText: '' });
				const requestPayload = {
					...defaultOkrFormDetails,
					status: Enums.TWO,
					goalStatusId: Enums.TWO,
					goalTypeId: Enums.TWO,
					myGoalsDetails:
						defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails?.length
							? defaultOkrFormDetails?.myGoalsDetails
									?.filter((rec: any) => rec?.keyDescription || rec?.keyDescription?.trim() !== '')
									.map((rec: any) => {
										return {
											...rec,
											status: Enums.TWO,
											goalStatusId: Enums.TWO,
											goalTypeId: Enums.TWO,
											isUpdatedNotPublished: false,
										};
									})
							: [],
				};
				// Need to check KR Status based on isKrEdited flag
				delete requestPayload.selectedListDetails;
				// console.log('handlePublishDefaultOkrClick ===>', requestPayload);
				let response: any = null;
				if (mode === 'Add') {
					response = await dispatch(createDefaultKpi([requestPayload]));
				} else if (mode === 'Edit') {
					response = await dispatch(editDefaultKpi([requestPayload]));
				}
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					setShowLoader(false);
					// NEED TO UPDATE
					setHighlightDefaultOkr(response?.data?.entity?.goalObjectiveId);
					selectedOkrListCycleValue && setSelectedOkrListCycleDetails(selectedOkrListCycleValue);
					handleBackButtonOnClick();
					showApiMsgs(response?.data?.messageList.Result, 'success');
					dispatch(setKpiListReload(true));
					dispatch(setShowKpiCreateOpen(false));
				} else {
					setShowLoader(false);
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					enqueueSnackbar(messages || t('savingDraftError'), {
						variant: 'error',
						autoHideDuration: 3000,
					});
				}

				setIsDefaultOkrFormEdited(false);
				setShowLoader(false);
			}
		} catch (error) {
			console.error(error);
			enqueueSnackbar(t('savingDraftError'), {
				variant: 'error',
				autoHideDuration: 3000,
			});
			setShowLoader(false);
		}
	};
	const checkDisableButton = () => {
		const isDisable = !keyData?.metricId
			? true
			: keyData?.metricId === Enums.TWO && !keyData?.currencyId
			? true
			: false;

		return isDisable;
	};

	// console.log('CreateDefaultOkr ===> ', mode, defaultOkrFormDetails);

	return (
		<>
			<Box className='create-kpi-card-wrap'>
				<div ref={refObject}>
					<CreateDefaultKpiDetails
						handleKrDrawerOpen={handleKrDrawerOpen}
						defaultOkrFormDetails={defaultOkrFormDetails}
						handleObjectiveNameChange={handleObjectiveNameChange}
						setDefaultOkrFormDetails={setDefaultOkrFormDetails}
						handleKrNameChange={handleKrNameChange}
						handleKrProgressChange={handleKrProgressChange}
						handleOkrDeletionClick={handleOkrDeletionClick}
						handleKRDeletionClick={handleKRDeletionClick}
						selectedCycleDetails={selectedCycleDetails}
						handleDraftDefaultOkrClick={handleDraftDefaultOkrClick}
						handleSaveAndPublishLaterDefaultOkrClick={handleSaveAndPublishLaterDefaultOkrClick}
						handlePublishDefaultOkrClick={handlePublishDefaultOkrClick}
						okrNameError={okrNameError}
						setOkrNameError={setOkrNameError}
						okrRoleError={okrRoleError}
						showLoader={showLoader}
						handleIsWeightSameToggleClick={handleIsWeightSameToggleClick}
						handleIsTargetSameToggleClick={handleIsTargetSameToggleClick}
						handleKrStartTargetValueChange={handleKrStartTargetValueChange}
						handleKrRoleStartTargetValueChange={handleKrRoleStartTargetValueChange}
						handleWeightUpdate={handleWeightUpdate}
						handleKrRoleSearch={handleKrRoleSearch}
						handleKrRoleSort={handleKrRoleSort}
						handleKrExpandCollapse={handleKrExpandCollapse}
						weightSelectionOpen={weightSelectionOpen}
						setWeightSelectionOpen={setWeightSelectionOpen}
						handleDrawerOpen={handleDrawerOpen}
					/>
					{openDefaultKrDrawer && openDefaultKrDrawer?.open ? (
						<MainDrawer
							open={openDefaultKrDrawer.open}
							drawerClassName={'main-drawer-panel main-drawer-titlepanel default-kr-attribute-panel'}
							transitionDuration={{ enter: 500, exit: 1000 }}
							headerTitle={t('kpiAttributes')}
							loader={showLoader}
							children={
								<Box className='drawer-inner-content'>
									<DefaultKpiAttributes
										{...props}
										mode={mode}
										defaultOkrFormDetails={defaultOkrFormDetails}
										krDetails={openDefaultKrDrawer?.details ? openDefaultKrDrawer?.details : null}
										selectedDefaultKrTab={selectedDefaultKrTab}
										handleTabChange={handleTabChange}
										allCycleDetails={allCycleDetails}
										// selectedKrDateRange={selectedKrDateRange}
										// setSelectedKrDateRange={setSelectedKrDateRange}
										isCurrentCycle={isCurrentCycle}
										selectedKrCycleDetails={selectedCycleDetails}
										setSelectedKrCycleDetails={setSelectedCycleDetails}
										keyData={keyData}
										setKeyData={setKeyData}
										krAttributeEdited={krAttributeEdited}
										setKrAttributeEdited={setKrAttributeEdited}
									/>
								</Box>
							}
							isSaveButtonDisabled={checkDisableButton()}
							saveButtonText={t('saveBtn')}
							handleDrawerClose={(event: any) => handleKrDrawerClose(event, 'close')}
							handleSaveClick={(event: any) => handleKrDrawerClose(event, 'save')}
							handleCancelClick={(event: any) => handleKrDrawerClose(event, 'cancel')}
						/>
					) : (
						<></>
					)}
				</div>
			</Box>
			{modalPerformanceProps && modalPerformanceProps.open && (
				<AlertDialog
					module='PerformanceReviewList'
					isCancel={false}
					message={modalPerformanceProps?.message || ''}
					handleCloseModal={handlePerformanceCloseModal}
					modalOpen={modalPerformanceProps.open}
				/>
			)}
			{showErrorMessageModal && showErrorMessageModal.open && (
				<AlertDialog
					module='PerformanceReviewList'
					isCancel={true}
					message={showErrorMessageModal?.message || ''}
					handleCloseModal={() => {
						setShowErrorMessageModal(false);
					}}
					modalOpen={showErrorMessageModal.open}
				/>
			)}
			{modalProps && modalProps.open && (
				<DialogComponent
					module={modalProps.module || 'defaultKR'}
					modalOpen={modalProps.open}
					handleCloseModal={(e: any) => handleConfirmationCloseModal(e, 2)}
					matchString={modalProps?.details?.matchString || Enums.DELETE_TEXT}
					handleConfirmClick={(e: any) => handleConfirmationCloseModal(e, 1)}
					confirmMsg={modalProps?.details?.confirmMsg || ''}
					headingText={modalProps?.details?.headingText || ''}
					subHeading={modalProps?.details?.subHeading || ''}
				/>
			)}
		</>
	);
};
